import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksMeasures(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		dtConfig[ModulesMap.DONE_WORKS_MEASURES].getDoneWorksMeasures,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorksMeasurePreview(companyId, doneWorkId, measureId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		dtConfig[ModulesMap.DONE_WORKS_MEASURES].getDoneWorksMeasurePreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				measureId,
			},
		},
	)
}
function getDoneWorksMeasurePopup(companyId, doneWorkId, measureId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		dtConfig[ModulesMap.DONE_WORKS_MEASURES].getDoneWorksMeasurePopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				measureId,
			},
		},
	)
}

function createDoneWorksMeasure(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MEASURES,dtConfig[ModulesMap.DONE_WORKS_MEASURES].createDoneWorksMeasure, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function getDoneWorksMeasure(companyId, doneWorkId, measureId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MEASURES,dtConfig[ModulesMap.DONE_WORKS_MEASURES].getDoneWorksMeasure, {
		urlParams: {
			companyId,
			doneWorkId,
			measureId,
		},
	})
}

function patchDoneWorksMeasure(companyId, doneWorkId, measureId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MEASURES,dtConfig[ModulesMap.DONE_WORKS_MEASURES].patchDoneWorksMeasure, {
		urlParams: {
			companyId,
			doneWorkId,
			measureId,
		},
		...data,
	})
}

function patchDoneWorksMeasureBulkUpdate(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MEASURES,dtConfig[ModulesMap.DONE_WORKS_MEASURES].patchDoneWorksMeasureBulkUpdate, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function postDoneWorksMeasureBulkCreate(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MEASURES,dtConfig[ModulesMap.DONE_WORKS_MEASURES].postDoneWorksMeasureBulkCreate, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function putDoneWorksMeasure(companyId, doneWorkId, measureId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MEASURES,dtConfig[ModulesMap.DONE_WORKS_MEASURES].putDoneWorksMeasure, {
		urlParams: {
			companyId,
			doneWorkId,
			measureId,
		},
		...data,
	})
}

function deleteDoneWorksMeasure(companyId, doneWorkId, measureId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MEASURES,dtConfig[ModulesMap.DONE_WORKS_MEASURES].deleteDoneWorksMeasure, {
		urlParams: {
			companyId,
			doneWorkId,
			measureId,
		},
	})
}

export default {
	getDoneWorksMeasures,
	getDoneWorksMeasurePopup,
	getDoneWorksMeasurePreview,
	getDoneWorksMeasure,
	patchDoneWorksMeasure,
	patchDoneWorksMeasureBulkUpdate,
	postDoneWorksMeasureBulkCreate,
	putDoneWorksMeasure,
	createDoneWorksMeasure,
	deleteDoneWorksMeasure,
}
